import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import TablePagination from "@mui/material/TablePagination";
import Typography from "@mui/material/Typography";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import TablePaginationActions from "../../../shared/components/Table/Actions";
import { page } from "../SalaParticipante/api-sala-participante";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import Loading from "../../UI/Loading";
import MensagemUser from "../MensagemUser";

const POLLING_INTERVAL = 10000;

const EMPTY_PAGE = { content: [], size: 0, totalElements: 0, number: 0 };

const getNameRoom = (sp) => (sp.sala.isGroup ? sp.sala.descricao : sp.usuario.nome);

export const EmptyMensagens = ({ children }) => (
  <Box
    sx={{
      py: 6,
      textAlign: "center",
      color: "text.secondary",
      border: 1,
      borderStyle: "dashed",
      borderColor: "divider",
      borderRadius: 2,
    }}
  >
    <ForumOutlinedIcon fontSize="large" />
    <Typography variant="body2" mt={1}>
      {children}
    </Typography>
  </Box>
);

export default function MensagemListUser() {
  const [salasParticipante, setSalasParticipante] = useState(EMPTY_PAGE);
  const [pageNumber, setPageNumber] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const load = (showLoading) => {
      if (showLoading) setIsLoading(true);
      return page(pageNumber)
        .then((data) => {
          if (!active || !data) return;
          if (data.error) {
            // Erros do polling não interrompem o usuário com alertas repetidos.
            if (showLoading) errorMessage(data.message);
          } else {
            setSalasParticipante(data);
          }
        })
        .finally(() => {
          if (active && showLoading) setIsLoading(false);
        });
    };

    load(true);
    // Busca novas mensagens periodicamente, apenas com a aba visível.
    const interval = setInterval(() => {
      if (!document.hidden) load(false);
    }, POLLING_INTERVAL);

    return () => {
      active = false;
      clearInterval(interval);
    };
  }, [pageNumber]);

  if (isLoading) {
    return (
      <Box py={6}>
        <Loading description="Carregando Salas..." />
      </Box>
    );
  }

  if (salasParticipante.content.length === 0) {
    return <EmptyMensagens>Nenhuma conversa encontrada.</EmptyMensagens>;
  }

  return (
    <Box>
      <List disablePadding sx={{ border: 1, borderColor: "divider", borderRadius: 2, overflow: "hidden" }}>
        {salasParticipante.content.map((sp) => (
          <MensagemUser key={sp.codigo} sp={sp} getNameRoom={getNameRoom} />
        ))}
      </List>
      <TablePagination
        rowsPerPageOptions={[]}
        rowsPerPage={salasParticipante.size || 0}
        component="div"
        count={salasParticipante.totalElements}
        page={salasParticipante.number}
        onPageChange={(event, newPage) => setPageNumber(newPage)}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? `${count} registros` : `mais de ${to}`}`
        }
        ActionsComponent={TablePaginationActions}
      />
    </Box>
  );
}
